// extracted by mini-css-extract-plugin
export default {"mainContainer":"ExciseWarehouseRequestLicence_mainContainer__A2Jme"};